'use strict';

angular.module('mx.components').directive('mxBindHtmlTrusted', function mxBindHtmlTrustedDirective() {
	return {
		restrict: 'A',
		bindToController: {
			mxBindHtmlTrusted: '<',
		},
		scope: {},
		controller: MxBindHtmlTrustedController,
	};
});

MxBindHtmlTrustedController.$inject = ['$scope', '$element'];
function MxBindHtmlTrustedController($scope, $element) {
	this.$onChanges = (changes) => {
		if (changes.mxBindHtmlTrusted) {
			$element.html(changes.mxBindHtmlTrusted.currentValue);
		}
	};
}
